import {appAPI} from "../../../api";
import {IMachineryGroup} from "../../../models/iMachineryGroup";
import {ISharedGroupView} from "../../../models/iSharedGroup";
import {IGroupReport} from "../../../models/iGroupReport";
import {UNGROUPED_SCOPE_ID} from "../../../models/iMachineryGroup";

const groupsPath = `/machinery-groups`;
const sharedPath = `/shared`;

export const machineryGroupsAPI = {
    getAll: async (): Promise<IMachineryGroup[]> => {
        const res = await appAPI.get(groupsPath);
        return res.data;
    },

    add: async (name: string): Promise<IMachineryGroup> => {
        const res = await appAPI.post(groupsPath, {name});
        return res.data;
    },

    update: async (id: string, name: string): Promise<IMachineryGroup> => {
        const res = await appAPI.patch(`${groupsPath}/${id}`, {name});
        return res.data;
    },

    delete: async (id: string): Promise<{id: string}> => {
        const res = await appAPI.delete(`${groupsPath}/${id}`);
        return res.data;
    },

    /**
     * Полная перезапись состава: PUT, а не PATCH — машины, которых нет в
     * machinery_ids, из группы отцепляются.
     */
    setMembers: async (id: string, machinery_ids: string[]): Promise<IMachineryGroup> => {
        const res = await appAPI.put(`${groupsPath}/${id}/members`, {machinery_ids});
        return res.data;
    },

    /** Выпустить или перевыпустить гостевую ссылку (старая перестаёт работать). */
    createShare: async (id: string): Promise<IMachineryGroup> => {
        const res = await appAPI.post(`${groupsPath}/${id}/share`);
        return res.data;
    },

    /**
     * Отчёт за период (кабинет). from/to — 'YYYY-MM-DD'.
     *
     * id === UNGROUPED_SCOPE_ID уводит на отдельный маршрут: «без группы» —
     * это не группа с таким id, а вся техника компании вне групп.
     */
    getReport: async (id: string, from: string, to: string): Promise<IGroupReport> => {
        const path =
            id === UNGROUPED_SCOPE_ID
                ? `${groupsPath}/ungrouped/report`
                : `${groupsPath}/${id}/report`;
        const res = await appAPI.get(path, {params: {from, to}});
        return res.data;
    },

    /** Отозвать гостевую ссылку. */
    revokeShare: async (id: string): Promise<IMachineryGroup> => {
        const res = await appAPI.delete(`${groupsPath}/${id}/share`);
        return res.data;
    },
};

/**
 * Публичный доступ по ссылке. Отдельный объект, а не метод machineryGroupsAPI:
 * этот запрос уходит БЕЗ авторизации и живёт в другом контексте (гостевая
 * страница), путать его с кабинетными вызовами не нужно.
 */
export const sharedGroupAPI = {
    getByToken: async (token: string): Promise<ISharedGroupView> => {
        const res = await appAPI.get(`${sharedPath}/${encodeURIComponent(token)}`);
        return res.data;
    },

    /** Тот же отчёт, что в кабинете, но доступ даёт токен ссылки. */
    getReport: async (token: string, from: string, to: string): Promise<IGroupReport> => {
        const res = await appAPI.get(`${sharedPath}/${encodeURIComponent(token)}/report`, {
            params: {from, to},
        });
        return res.data;
    },
};
